// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__21-tQ","info":"PatientInfo_info__1d46X"};